import { useState, useEffect } from 'react';
import { getUnsignedTimesheetsCount } from '../services/api/timekeeping';
import { BRAND_COLORS } from '../config';

/**
 * Custom hook to manage unsigned timesheets data
 * @param {Object} contextUser - The current user context
 * @returns {Object} Object containing count and color for unsigned timesheets
 */
export const useUnsignedTimesheets = (contextUser) => {
  const [unsignedSheets, setUnsignedSheets] = useState({
    count: 0,
    color: BRAND_COLORS.status.error,
  });

  useEffect(() => {
    // Only fetch if user has appropriate roles
    if (
      contextUser &&
      (contextUser.manager || contextUser.executive || contextUser.staff)
    ) {
      const fetchUnsignedSheets = async () => {
        try {
          const result = await getUnsignedTimesheetsCount();
          setUnsignedSheets({
            count: result.count || 0,
            color:
              result.count > 0
                ? BRAND_COLORS.status.error
                : BRAND_COLORS.status.success,
          });
        } catch (error) {
          console.error("Error fetching unsigned timesheets:", error);
          setUnsignedSheets({ 
            count: 0, 
            color: BRAND_COLORS.status.success 
          });
        }
      };

      fetchUnsignedSheets();
    }
  }, [contextUser]);

  return unsignedSheets;
};
